import { render, staticRenderFns } from "./pagamentos.vue?vue&type=template&id=73bedd5c&scoped=true&"
import script from "./pagamentos.vue?vue&type=script&lang=js&"
export * from "./pagamentos.vue?vue&type=script&lang=js&"
import style0 from "./pagamentos.vue?vue&type=style&index=0&id=73bedd5c&prod&lang=scss&scoped=true&"
import style1 from "./pagamentos.vue?vue&type=style&index=1&id=73bedd5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bedd5c",
  null
  
)

export default component.exports